import { CollectionsLobbyEventTypes } from '../types';
import { createGrafanaEvent } from '../../../../../shared/utils/events/grafana/base';

const { header, collectionCard, viewFilter, emptyView, modals } = CollectionsLobbyEventTypes;

export const CollectionsLobbyGrafanaEvents = {
    [header.actions.createCollection.clicked]: createGrafanaEvent(
        'collections_lobby.header_actions.create_collection_clicked'
    ),

    [collectionCard.clicked]: createGrafanaEvent('collections_lobby.collection_card_clicked'),
    [collectionCard.actions.shareWithTeam.clicked]: createGrafanaEvent(
        'collections_lobby.collection_card_action_clicked.share_with_team'
    ),
    [collectionCard.actions.socialShare.clicked]: createGrafanaEvent(
        'collections_lobby.collection_card_action_clicked.social_share'
    ),
    [collectionCard.actions.edit.clicked]: createGrafanaEvent('collections_lobby.collection_card_action_clicked.edit'),
    [collectionCard.actions.delete.clicked]: createGrafanaEvent(
        'collections_lobby.collection_card_action_clicked.delete'
    ),

    [viewFilter.changed]: createGrafanaEvent('collections_lobby.view_filter_changed'),
    [emptyView.actions.createCollection.clicked]: createGrafanaEvent(
        'collections_lobby.empty_create_collection_clicked'
    ),

    [modals.createCollection.show]: createGrafanaEvent('collections_lobby.create_collection_modal.show'),
    [modals.createCollection.cancel]: createGrafanaEvent('collections_lobby.create_collection_modal.cancel'),
    [modals.createCollection.submit]: createGrafanaEvent('collections_lobby.create_collection_modal.submit'),
    [modals.createCollection.fail]: createGrafanaEvent('collections_lobby.create_collection_modal.fail'),
};
